import { Table, Text } from "@mantine/core";
import { HeldEmailListItem } from "../../../services/admin/systemEmails.service";
import { HeldEmailStateBadge } from "./HeldEmailStateBadge";

interface HeldEmailQueueStatusCellsProps {
  email: HeldEmailListItem;
}

export function HeldEmailQueueStatusCells({
  email,
}: HeldEmailQueueStatusCellsProps) {
  return (
    <>
      <Table.Td>
        <HeldEmailStateBadge state={email.state} />
      </Table.Td>
      <Table.Td>
        <Text size="sm">{new Date(email.createdAt).toLocaleString()}</Text>
      </Table.Td>
    </>
  );
}
